<template>
  <div class="fullbox">
    <div class="preview-top flex align_center space_center pdt10 pdb10">
      <van-button type="info" size="small" @click="prePage"
        ><van-icon name="arrow-left" /> 上一页
      </van-button>
      <div class="tip">{{ pageNum }} / {{ pageTotalNum }}</div>
      <van-button type="info" @click="nextPage" size="small" class="mr15"
        >下一页 <van-icon name="arrow"
      /></van-button>
    </div>
    <div class="preview-content flex space_center">
      <pdf
        :page="pageNum"
        :src="fileLink"
        @progress="loadedRatio = $event"
        @num-pages="pageTotalNum = $event"
        style="width: 100%"
      ></pdf>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  name: "preview",
  components: { pdf },
  props: {
    selectFile: {
      //默认选中数据
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      fileName: "",
      fileLink: "",
      numPages: null, // pdf 总页数
      pageNum: 1,
      pageTotalNum: 1, //# 总页数
      loadedRatio: 0, //# 当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了
    };
  },
  created() {
    this.fileName = this.selectFile.fileName;
    this.fileLink = this.selectFile.url;
  },
  mounted() {
    this.getNumPages();
  },
  methods: {
    //# 计算pdf页码总数
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.fileLink);

      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    // 上一页
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    // 下一页
    nextPage() {
      let page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
    download() {
      var alink = document.createElement("a");
      alink.href = this.fileLink;
      alink.download = this.fileName; //图片名
      alink.click();
    },
  },
  computed: {
    link() {
      return "pdf/web/viewer.html?file=" + this.fileLink;
    },
  },
};
</script>

<style lang="less" scoped>
.flex,
.flex_box {
  display: flex;
  display: -webkit-flex;
}
.align_center {
  align-items: center;
}
.space_center {
  justify-content: space-between;
}
.preview-top {
  width: 220px;
  margin: 0 auto;
  .tip {
    padding: 0 15px;
  }
}
.preview-content {
  margin-top: 20px;
  height: calc(100% - 20px);
  overflow: auto;
}
</style>